import { render, staticRenderFns } from "./ForBidden.vue?vue&type=template&id=482835ab&"
import script from "./ForBidden.vue?vue&type=script&lang=js&"
export * from "./ForBidden.vue?vue&type=script&lang=js&"
import style0 from "./ForBidden.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports